import { getToken, isSupported } from 'firebase/messaging';
import { initFirebasePush } from '@/Firebase';
import { pushNotifications } from '@/Config';
import Resources from '@/Resources';
import Log from '@/Utils/Log';

export const browserNotificationsHelp = {
    ['Chrome']: 'https://support.google.com/chrome/answer/3220216?hl=en&co=GENIE.Platform%3DDesktop&sjid=1922211121441663234-EU',
    ['Firefox']: 'https://support.mozilla.org/en-US/kb/push-notifications-firefox',
    ['Safari']: 'https://support.apple.com/en-hk/guide/safari/sfri40734/17.0/mac/14.0',
    ['Samsung Internet']: 'https://www.samsung.com/hk_en/support/mobile-devices/deactivate-notifications-from-websites-on-my-samsung-phone/',
    ['Edge']: 'https://support.microsoft.com/en-us/microsoft-edge/manage-website-notifications-in-microsoft-edge-0c555609-5bf2-479d-a59d-fb30a0b80b2b',
    ['Other']: 'https://help.gamefound.com/article/385-how-do-i-enable-push-notifications-on-my-browser?',
};

export const states = {
    default: 'default',
    denied: 'denied',
    granted: 'granted',
    unauthorized: 'unauthorized',
};

export const isBrowserSupported = async () => {
    return await isSupported();
};

export const getPermission = async () => {
    const messaging = initFirebasePush();

    if (!messaging) {
        Log.warn('Firebase Messaging is not initialized');
        return null;
    }

    // Add timeout to prevent hanging in Edge when prompt is silently blocked
    const permission = await Promise.race([
        Notification.requestPermission(),
        new Promise((resolve) =>
            setTimeout(() => resolve(), 10000),
        )]);
    if (permission !== states.granted) return false;

    try {
        // Add timeout to prevent hanging in Opera
        const registration = await Promise.race([
            navigator.serviceWorker.ready,
            new Promise((_, reject) =>
                setTimeout(() => reject(new Error('Service Worker timeout after 10 seconds')), 10000),
            ),
        ]);

        const currentToken = await getToken(messaging,
            {
                vapidKey: pushNotifications.vapidKey,
                serviceWorkerRegistration: registration,
            });

        if (!currentToken) {
            throw new Error('Failed to get FCM token');
        }

        return currentToken;
    }
    catch (error) {
        Log.error(error);
        throw new Error(
            Resources.SubscriptionManagement.PushNotificationsDeviceTokenInvalidErrorMessage,
        );
    }
};

export function webPushCapability() {
    return 'PushManager' in window && 'serviceWorker' in navigator && 'permissions' in navigator && 'Notification' in window;
}